module.exports = __webpack_public_path__ + "media/images/home/logo-hulu-white-581440ffc4b950347e3a302955cf84ad.svg";